import * as angular from 'angular';
import { getGroupName } from '../../common';
import { ComponentDefinition, Group, GroupDisplayName, GroupNameDto } from '../../models';

class GroupNameDisplayController implements angular.IComponentController {
    name: string;
    params: any;
    state: string;

    readonly beginDate: string;
    readonly disableIcon = false;
    readonly displayedName: GroupDisplayName;
    readonly endDate: string;
    readonly group: Group | GroupNameDto;
    readonly isEditMode: boolean;
    readonly parentStyle: any;
    readonly ref: string;
    readonly uniqueName: boolean;

    static $inject = ['$scope'];

    constructor(private _$scope: angular.IScope) {
    }

    $onInit() {
        this.state = `group.${this.ref ? this.ref : 'general'}`;
        this.computeName();
        this._$scope.$watch(
            () => this.group,
            () => {
                if (this.group) {
                    this.updateParams();
                }
            }
        );
    }

    $onChanges(changesObj) {
        this.updateParams();
    }

    private computeName() {
        if (this.group) {
            this.name = this.displayedName !== undefined
                ? getGroupName(this.group, this.displayedName)
                : this.uniqueName ? this.group.uniqueName : this.group.name;
        } else {
            this.name = '';
        }
    }

    private updateParams() {
        this.computeName();
        this.params = {
            groupGuid: this.group?.guid,
            beginDate: this.beginDate ? this.beginDate : '',
            endDate: this.endDate ? this.endDate : ''
        };
    }
}

export const wtGroupNameDisplay: ComponentDefinition = {
    componentId: 'wtGroupNameDisplay',
    controller: GroupNameDisplayController,
    controllerAs: 'vm',
    template: require('./groupNameDisplay.component.html'),
    bindings: {
        beginDate: '<?',
        disableIcon: '@?',
        displayedName: '<?',
        endDate: '<?',
        group: '<',
        isEditMode: '<?',
        parentStyle: '<?',
        ref: '@?',
        uniqueName: '<?'
    }
};